module.exports = __webpack_public_path__ + "img/hexe.c10fc963.png";